import { createFileRoute } from '@tanstack/react-router'

import PageLogin from '@/pages/PageLogin'

type LoginSearch = {
  returnTo?: string
}

export const Route = createFileRoute('/login')({
  component: PageLogin,
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    returnTo: typeof search.returnTo === 'string' ? search.returnTo : undefined
  })
})
